import { render, staticRenderFns } from "./service-locations-signature-card.vue?vue&type=template&id=3234b2ae&scoped=true&"
import script from "./service-locations-signature-card.vue?vue&type=script&lang=js&"
export * from "./service-locations-signature-card.vue?vue&type=script&lang=js&"
import style0 from "./service-locations-signature-card.vue?vue&type=style&index=0&id=3234b2ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3234b2ae",
  null
  
)

export default component.exports